<template lang="pug">
v-card.rounded-lg(color="white" flat :height="height")
  .pa-4
    .text-lg.font-semibold {{ type | capitalize }} ranking
  v-divider
  .pa-4
    v-skeleton-loader.px-4(type="article" v-if="isLoading")
    .data-table(v-else style="padding-bottom: 70px")
      v-data-table(:headers="headers" :items="items" hide-default-footer mobile-breakpoint="0" :header-props="{ sortIcon: '$yzi-triangle' }")
        template(v-slot:item.sales_amount="{ item }")
          div {{ item.sales_amount | displayPriceNoCent }}
        template(v-slot:item.provider="{ item }")
          div {{ item.first_name }} {{ item.last_name }}
        template(v-slot:item.leads_count="{ item }")
          .text-right {{ item.leads_count }}
        template(v-slot:item.unit_sold="{ item }")
          .text-right {{ item.unit_sold }}
        template(v-slot:item.billed_amount="{ item }")
          div {{ item.billed_amount | displayPrice }}
        template(v-slot:item.rejected_amount="{ item }")
          div {{ item.rejected_amount | displayPrice }} ({{ item.rejected_pct | toDecimalPlaces(1) }}%)
        template(v-slot:item.revenue_amount="{ item }")
          div {{ item.revenue_amount | displayPrice }}
        template(v-slot:item.due_amount="{ item }")
          div {{ item.due_amount | displayPrice }}
        template(v-slot:item.unpaid_amount="{ item }")
          div {{ item.unpaid_amount | displayPrice }}

    .bottom-0.left-0.right-0.absolute.pa-6.white.round-lg
      .d-flex.align-center
        v-spacer
        y-button(label="View all" size="sm" @click="showRankingDialog = true" outlined)

  .dialogs
    ranking-table-dialog(v-if="showRankingDialog" :open.sync="showRankingDialog" :providers="providers" :type="type" :begin="begin" :until="until")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import RankingTableDialog from './RankingTableDialog.vue'

export default {
  name: 'RankingCard',
  props: {
    type: {
      type: String,
      required: true,
    },
    providers: {
      type: Array,
      default: () => null
    },
    begin: {
      type: String
    },
    until: {
      type: String
    },
  },
  components: { RankingTableDialog },
  data: () => ({
    isLoading: false,
    showRankingDialog: false,
    items: [],
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      selectedCompanies: 'insight/getSelectedCompanies',
      isHq: 'hq/getIsHq'
    }),
    height () {
      // return this.type === 'panel' ? 450 : 640
      return '100%'
    },
    headers () {
      switch (this.type) {
        case 'services':
          return [
            { text: '#', value: 'index' },
            { text: 'Services', value: 'name' },
            { text: 'Sales', value: 'sales_amount'  },
            { text: 'Patients', value: 'leads_count' },
          ]
        case 'medication':
          return [
            { text: '#', value: 'index' },
            { text: 'Medication', value: 'name' },
            { text: 'Sales', value: 'sales_amount'  },
            { text: 'Unit Sold', value: 'unit_sold' },
          ]
        case 'packages':
          return [
            { text: '#', value: 'index' },
            { text: 'Packages', value: 'name' },
            { text: 'Sales', value: 'sales_amount'  },
            { text: 'Unit Sold', value: 'unit_sold' },
          ]
        case 'provider':
          return [
            { text: '#', value: 'index' },
            { text: 'Doctor', value: 'provider' },
            { text: 'Sales', value: 'sales_amount'  },
            { text: 'Patients', value: 'leads_count' },
          ]
        case 'branch':
          return [
            { text: '#', value: 'index' },
            { text: 'Branch', value: 'branch' },
            { text: 'Sales', value: 'sales_amount'  },
            { text: 'Patients', value: 'leads_count' },
          ]
        case 'panel':
          return [
            { text: '#', value: 'index' },
            { text: 'Panel Name', value: 'name' },
            { text: 'Billed', value: 'billed_amount' },
            { text: 'Rejected', value: 'rejected_amount' },
            { text: 'Revenue', value: 'revenue_amount' },
            { text: 'Due', value: 'due_amount' },
          ]
        case 'outstanding':
          return [
            { text: 'Name', value: 'name' },
            { text: 'Sales', value: 'unpaid_amount' },
          ]
        default:
          return []
      }
    },
    rankingEndpoint () {
      switch (this.type) {
        case 'services':
          return 'sales/services'
        case 'medication':
          return 'sales/medications'
        case 'packages':
          return 'sales/packages'
        case 'provider':
          return 'sales/providers'
        case 'panel':
          return 'payments/panels'
        case 'outstanding':
          return 'invoices'
        default:
          return ''
      }
    },
  },
  watch: {
    providers: {
      handler() {
        this.fetchData()
      },
      deep: true
    },
    begin () {
      this.fetchData()
    },
    selectedCompanies: {
      handler() {
        this.fetchData()
      },
      deep: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.fetchData()
    })
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchData (stopRefetch) {
      if (!this.begin) { return }
      this.isLoading = true
      let params = {
        page_size: 10,
        form_type: 'registration',
        begin: this.begin,
        until: this.until
      }

      // Handle HQ vs regular company logic
      if (this.isHq) {
        if (this.selectedCompanies) {
          params.companies = this.selectedCompanies.map(c => c.id).join(',')
        } else {
          params.hq = this.company.id
        }
      } else {
        params.company = this.company.id
      }

      if (this.providers && this.providers.length > 0) {
        params.providers = this.providers.map(p => p.id).join(',')
      }
      this.$axios.get(`/rankings/${this.company.slug}/${this.rankingEndpoint}`, { params })
        .then(resp => {
          let items = []
          let size = this.type === 'panel' ? 5 : 10
          resp.data.results.forEach((row, index) => {
            if (index < size) {
              items.push({ ...row, index: index + 1 })
            }
          })
          this.items = items
          this.isLoading = false
        })
        .catch(() => {
          if (!stopRefetch) {
            this.fetchData(true)
          } else {
            this.isLoading = false
          }
        })
    }
  }
}
</script>